/* Keep the existing apps: use Klaviyo's explicit form trigger and the original chat launcher. */
if (!customElements.get('mc-editorial-services')) {
  customElements.define('mc-editorial-services', class extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      const sources = {
        // The in-page offer is independent of the removed floating offer bar.
        offer: () => Boolean(this.dataset.offerFormId),
        chat: () => Boolean(document.querySelector('.melachill-chat-launcher')),
      };
      const sync = () => {
        for (const [action, isAvailable] of Object.entries(sources)) {
          const available = isAvailable();
          const button = this.querySelector(`[data-editorial-action="${action}"]`);
          if (button) button.hidden = !available;
          document.body.classList.toggle(`mc-editorial-${action}-ready`, available);
        }
        if (Object.values(sources).every(isAvailable => isAvailable())) this.observer?.disconnect();
      };
      this.addEventListener('click', event => {
        const button = event.target.closest('[data-editorial-action]');
        if (!button || !this.contains(button)) return;
        if (button.dataset.editorialAction === 'offer' && this.dataset.offerFormId) {
          // An explicit click must also work when Klaviyo suppresses its automatic teaser.
          window._klOnsite = window._klOnsite || [];
          window._klOnsite.push(['openForm', this.dataset.offerFormId]);
          return;
        }
        if (button.dataset.editorialAction === 'chat') {
          // Do not synthesize a second mouse click: Shopify's capture-phase
          // outside-click guard must see the original opening gesture only.
          event.stopPropagation();
          document.dispatchEvent(new CustomEvent('melachill:open-chat'));
        }
      }, { signal: this.abort.signal });
      this.observer = new MutationObserver(sync);
      this.observer.observe(document.body, { childList: true, subtree: true });
      sync();
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.observer?.disconnect();
      queueMicrotask(() => {
        if (!document.querySelector('mc-editorial-services')) {
          document.body.classList.remove('mc-editorial-offer-ready', 'mc-editorial-chat-ready');
        }
      });
    }
  });
}
